module.exports = __webpack_public_path__ + "img/premium.68eed9a5.png";